import React, { Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";

import Post from "./Post";
import Header from "./Header";
import LeftCard from "./LeftCard";
import Footer from "./Footer";
import {
	Button,
	Alert,
	Card,
	CardImg,
	CardBody,
	CardTitle,
	CardSubtitle,
	CardText,
} from "react-bootstrap";

import theme, { GlobalStyles } from './FilesUploderComponent/UI-Components/Theme'
import { ThemeProvider } from '@mui/material'
import RoutingFile from './FilesUploderComponent/UI-Components/Routing-File'

const Home =() =>(
<ThemeProvider theme={theme}>
      <GlobalStyles/>
      <div className='fillOutPage property'>
	  <Header />
	  <main className="my-5 py-5">
			<Container className="px-0">
            
				<Row
					noGutters
					className="pt-2 pt-md-5 w-100 
						px-4 px-xl-0 position-relative"
				>
					{/* <Col
						xs={{ order: 2 }}
						md={{ size: 4, order: 1 }}
						tag="aside"
						className="pb-5 mb-5 pb-md-0 
							mb-md-0 mx-auto mx-md-0"
					>
                    <Fragment>
	
                    <Card> */}
        {/* <div className="video-responsive position-relative">
			
		<img
										src='./hometutor.jpeg'
										alt="avatar"
										
										style={{
											width: "auto",
											height: 315,
										}}
									/>
			</div> */}
        {/* </Card>
        </Fragment>
					</Col>

					<Col
						xs={{ order: 1 }}
						md={{ size: 7, offset: 1 }}
						tag="section"
						className="py-5 mb-5 py-md-0 mb-md-0"
					> */}
					 <Fragment><Card>
                     <div className="position-relative">
                     <article
							
						>
							<p style={{ textAlign: 'justify' }} >Sethu-AI is group of Datascience, Generative-AI professionals with a mission to bridge Generative-AI technology to common people.</p>

<p style={{ textAlign: 'justify' }}>The Generative AI professionals group is a collaborative community of experts and enthusiasts dedicated to advancing the field of generative artificial intelligence.Comprised of researchers, developers, data scientists, and industry practitioners, this group focuses on exploring the cutting-edge techniques and applications of 
generative models such as GPT, Llama, Phi and others also platforms like Ollama, OpenAI.Members engage in regular discussions, share the latest research findings, and collaborate on projects to push the boundaries of what AI can create in natural language processing. </p>
<p style={{ textAlign: 'justify' }}>Experienced in leveraging Generative AI with Retrieval-Augmented Generation (RAG) architecture to synthesize human-like text from diverse data sources.Proficient in integrating real-time data for dynamic and up-to-date outputs. Adept at creating impactful and personalized content for various applications.</p>
<p style={{ textAlign: 'justify' }}>Strong expertise in fine-tuning open-source large language models (LLMs) to meet specific business and research objectives. Proficient in using frameworks like Hugging Face, PyTorch, and TensorFlow to adapt pre-trained models for various NLP tasks, improving performance and efficiency. Skilled in optimizing model parameters, data pipelines, and training techniques to enhance model accuracy and generalization. Strong background in leveraging domain-specific datasets for customized fine-tuning, ensuring models are well-suited to production environments.</p>
						</article>
                        </div>

						</Card>
        </Fragment>
					{/* </Col> */}
				</Row></Container>
		</main>
	  <Footer />
     </div>
  </ThemeProvider>

)

const Home1 = () => (
	
	<Fragment>
		<Header />
        
		<main className="my-5 py-5">
			<Container className="px-0">
            
				<Row
					noGutters
					className="pt-2 pt-md-5 w-100 
						px-4 px-xl-0 position-relative"
				>
					{/* <Col
						xs={{ order: 2 }}
						md={{ size: 4, order: 1 }}
						tag="aside"
						className="pb-5 mb-5 pb-md-0 
							mb-md-0 mx-auto mx-md-0"
					> */}
                    {/* <Fragment>
	
                    <Card> */}
        {/* <div className="video-responsive position-relative"> */}
		{/* <img
										src='./sethu-ai.png'
										alt="avatar"
										
										style={{
											width: "auto",
											height: 315,
										}}
									/> */}
			{/* </div> */}
        {/* </Card>
        </Fragment> */}
					{/* </Col> */}

					<Col
						xs={{ order: 1 }}
						md={{ size: 7, offset: 1 }}
						tag="section"
						className="py-5 mb-5 py-md-0 mb-md-0"
					>
					 <Fragment><Card>
                     <div className="position-relative">
                     <article
							
						>
							<p style={{ textAlign: 'justify' }} >Sethu-AI is group of Datascience, Generative-AI professionals with a mission to bridge Generative-AI technology to common people.</p>

<p style={{ textAlign: 'justify' }}>The Generative AI professionals group is a collaborative community of experts and enthusiasts dedicated to advancing the field of generative artificial intelligence.Comprised of researchers, developers, data scientists, and industry practitioners, this group focuses on exploring the cutting-edge techniques and applications of 
generative models such as GPT, Llama, Phi and others also platforms like Ollama, OpenAI.Members engage in regular discussions, share the latest research findings, and collaborate on projects to push the boundaries of what AI can create in natural language processing. </p>
<p style={{ textAlign: 'justify' }}>Experienced in leveraging Generative AI with Retrieval-Augmented Generation (RAG) architecture to synthesize human-like text from diverse data sources.Proficient in integrating real-time data for dynamic and up-to-date outputs. Adept at creating impactful and personalized content for various applications.</p>
						</article>
                        </div>

						</Card>
        </Fragment>
					</Col>
				</Row></Container>
		</main><Footer />
	</Fragment>
);

export default Home;
